/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as querystring from "querystring";
import * as url from "url";

const isomorphicFetch = fetch;
const assign: (target: any, ...sources: any[]) => any = (Object as any).assign;

interface Dictionary<T> { [index: string]: T; }
export interface FetchAPI { (url: string, init?: any): Promise<any>; }

const BASE_PATH = "https://localhost".replace(/\/+$/, "");

export interface FetchArgs {
    url: string;
    options: any;
}

export class BaseAPI {
    basePath: string;
    fetch: FetchAPI;

    constructor(fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) {
        this.basePath = basePath;
        this.fetch = fetch;
    }
};

export interface AddAgreementVersionRequest {
    "description"?: string;
    "effectiveDate"?: Date;
}

export interface AdminUserResponse {
    "id"?: string;
    "userName"?: string;
    "normalizedUserName"?: string;
    "email"?: string;
    "normalizedEmail"?: string;
    "emailConfirmed"?: boolean;
    "passwordHash"?: string;
    "securityStamp"?: string;
    "concurrencyStamp"?: string;
    "phoneNumber"?: string;
    "phoneNumberConfirmed"?: boolean;
    "twoFactorEnabled"?: boolean;
    "lockoutEnd"?: Date;
    "lockoutEnabled"?: boolean;
    "accessFailedCount"?: number;
    "firstName"?: string;
    "lastName"?: string;
    "lastLogin"?: Date;
    "isActive"?: boolean;
    "role"?: string;
}

export interface Assembly {
    "definedTypes"?: Array<TypeInfo>;
    "exportedTypes"?: Array<Type>;
    "codeBase"?: string;
    "entryPoint"?: MethodInfo;
    "fullName"?: string;
    "imageRuntimeVersion"?: string;
    "isDynamic"?: boolean;
    "location"?: string;
    "reflectionOnly"?: boolean;
    "isCollectible"?: boolean;
    "isFullyTrusted"?: boolean;
    "customAttributes"?: Array<CustomAttributeData>;
    "escapedCodeBase"?: string;
    "manifestModule"?: Module;
    "modules"?: Array<Module>;
    "globalAssemblyCache"?: boolean;
    "hostContext"?: number;
    "securityRuleSet"?: SecurityRuleSet;
}

export interface BulkUnpairRequest {
    "cameraDeviceIds"?: Array<number>;
}

export interface BulkUpdateFleetRequest {
    "deviceUpdateFleets"?: Array<DeviceUpdateFleetRequest>;
}

export type CallingConventions = "Standard" | "VarArgs" | "Any" | "HasThis" | "ExplicitThis";

export type CameraDeviceChannelTypeEnum = "RoadFacing" | "DriverFacing" | "LeftFacing" | "RightFacing" | "Cargo" | "Rear" | "Auxiliary";

export interface CameraDeviceRemoteWakeAttemptsResponse {
    "canRemoteWake"?: boolean;
    "attemptsUsed"?: number;
    "attemptsRemaining"?: number;
    "attemptExpirationTime"?: Date;
}

export interface CameraDeviceResponse {
    "id"?: number;
    "deviceType"?: string;
    "serialNumber"?: string;
    "imei"?: string;
    "iccid"?: string;
    "lastHeartbeatTime"?: Date;
    "deviceStatus"?: CameraDeviceStatusEnum;
    "currentPairing"?: VehicleCameraPairingResponse;
    "fleetId"?: number;
}

export type CameraDeviceStateEnum = "Connected" | "Disconnected" | "Dormant";

export type CameraDeviceStatusEnum = "Active" | "Suspended" | "Retired" | "Expired" | "New" | "PendingSignature" | "Pairing" | "Disabled" | "Deprovisioned";

export type CameraDeviceTypeEnum = "VP200D" | "VP210D" | "VP220D" | "TestCamera" | "VP230D" | "VP240D" | "VP220S" | "VP240S" | "VP240SMax" | "VP240DMax";

export interface CameraResponse {
    "id"?: number;
    "fleetId"?: number;
    "cameraImei"?: string;
    "cameraSerialNumber"?: string;
    "cameraIccid"?: string;
    "isActive"?: boolean;
}

export interface ClientConfigResponse {
    "apmServiceUrl"?: string;
    "apmServiceName"?: string;
    "deployEnvironment"?: string;
    "integrationPlatform"?: string;
}

export interface ConstructorInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "attributes"?: MethodAttributes;
    "methodImplementationFlags"?: MethodImplAttributes;
    "callingConvention"?: CallingConventions;
    "isAbstract"?: boolean;
    "isConstructor"?: boolean;
    "isFinal"?: boolean;
    "isHideBySig"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isVirtual"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isConstructedGenericMethod"?: boolean;
    "isGenericMethod"?: boolean;
    "isGenericMethodDefinition"?: boolean;
    "containsGenericParameters"?: boolean;
    "methodHandle"?: RuntimeMethodHandle;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "memberType"?: MemberTypes;
}

export interface CreatePairingRequest {
    "fleetId"?: number;
    "cameraDeviceId"?: number;
    "vehicleName"?: string;
    "vehicleVin"?: string;
    "telematicProviderId"?: TelematicProviderIdEnum;
    "integrationPartnerVehicleId"?: string;
    "telematicType"?: string;
    "telematicSerialNumber"?: string;
    "vehicleCompanyLevelId"?: string;
    "vehicleCompanyLevelName"?: string;
    "isGpsTrackingEnabled"?: boolean;
}

export interface CreateUserRequest {
    "firstName": string;
    "lastName": string;
    "email": string;
    "roleName": string;
    "password": string;
}

export interface CustomAttributeData {
    "attributeType"?: Type;
    "constructor"?: ConstructorInfo;
    "constructorArguments"?: Array<CustomAttributeTypedArgument>;
    "namedArguments"?: Array<CustomAttributeNamedArgument>;
}

export interface CustomAttributeNamedArgument {
    "memberInfo"?: MemberInfo;
    "typedValue"?: CustomAttributeTypedArgument;
    "memberName"?: string;
    "isField"?: boolean;
}

export interface CustomAttributeTypedArgument {
    "argumentType"?: Type;
}

export interface DataUsageResponse {
    "usageDate"?: string;
    "quantity"?: number;
    "unit"?: string;
}

export interface DeviceAssociationValidationResponse {
    "isCurrentlyAssociated"?: boolean;
    "associatedWithIdentifier"?: string;
    "associatedSince"?: Date;
    "associatedWithType"?: string;
}

export interface DeviceBatchError {
    "msg"?: string;
    "uniqueId"?: string;
}

export interface DeviceBatchResponse {
    "errors"?: Array<DeviceBatchError>;
    "addedDevices"?: number;
    "processedDevices"?: number;
}

export interface DeviceDetailsResponse {
    "lastEventTimeUtc"?: Date;
    "failedEvents"?: Array<FailedEventCount>;
    "liveVideoUsageSeconds"?: number;
    "liveVideoRemainingSeconds"?: number;
    "remoteWakeAttempts"?: CameraDeviceRemoteWakeAttemptsResponse;
}

export interface DeviceFleetUpdate {
    "cameraDeviceId"?: number;
    "newFleetId"?: number;
}

export interface DeviceHealthResponse {
    "id"?: number;
    "clientName"?: string;
    "serialNumber"?: string;
    "iccid"?: string;
    "lastHeartbeatTime"?: Date;
    "lastProcessedEventTime"?: Date;
    "deviceStatus"?: string;
    "simStatus"?: string;
    "lastDataUsage"?: string;
    "lastGPSCommunication"?: Date;
    "lastKnownLocation"?: Location;
    "deviceTypeId"?: CameraDeviceTypeEnum;
}

export interface DeviceHealthResponseIEnumerablePagedResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<DeviceHealthResponse>;
    "currentPage"?: number;
    "itemsPerPage"?: number;
    "totalPages"?: number;
}

export type DeviceHistoryActionEnum = "PairingCreated" | "PairingDeleted" | "PairingUpdated";

export interface DeviceHistoryResponse {
    "action"?: DeviceHistoryActionEnum;
    "statusOfAction"?: string;
    "createdOn"?: Date;
    "createdBy"?: string;
}

export interface DeviceListDetailsResponse {
    "deviceId"?: number;
    "lastEventTimeUtc"?: Date;
}

export interface DeviceManagementFilterDataResponse {
    "clients"?: Array<DropdownMenuItem>;
    "cameras"?: Array<DropdownMenuItem>;
    "status"?: Array<DropdownMenuItem>;
}

export interface DeviceStorageState {
    "serialNumber"?: string;
    "storageTypes"?: Array<StrikerStorageStateEnum>;
}

export interface DeviceUpdateFleetRequest {
    "serialNumber": string;
    "newFleetName": string;
    "newCompanyId": string;
    "currentFleetName": string;
}

export interface DropdownMenuItem {
    "value"?: string;
    "label"?: string;
}

export interface EncompassCompanyLevelContainer {
    "companyId"?: string;
    "companyName"?: string;
}

export interface EncompassCompanyStructure {
    "cgRootId"?: string;
    "companyLevels"?: Array<EncompassCompanyLevelContainer>;
    "isRootVirtual"?: boolean;
}

export type EventAttributes = "None" | "SpecialName" | "RTSpecialName" | "ReservedMask";

export interface EventInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "attributes"?: EventAttributes;
    "isSpecialName"?: boolean;
    "addMethod"?: MethodInfo;
    "removeMethod"?: MethodInfo;
    "raiseMethod"?: MethodInfo;
    "isMulticast"?: boolean;
    "eventHandlerType"?: Type;
}

export interface Exception {
    "targetSite"?: MethodBase;
    "message"?: string;
    "data"?: any;
    "innerException"?: Exception;
    "helpLink"?: string;
    "source"?: string;
    "hResult"?: number;
    "stackTrace"?: string;
}

export interface FailedEventCount {
    "date"?: Date;
    "count"?: number;
}

export type FieldAttributes = "PrivateScope" | "Private" | "FamANDAssem" | "Assembly" | "Family" | "FamORAssem" | "Public" | "FieldAccessMask" | "Static" | "InitOnly" | "Literal" | "NotSerialized" | "HasFieldRVA" | "SpecialName" | "RTSpecialName" | "HasFieldMarshal" | "PinvokeImpl" | "HasDefault" | "ReservedMask";

export interface FieldInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "attributes"?: FieldAttributes;
    "fieldType"?: Type;
    "isInitOnly"?: boolean;
    "isLiteral"?: boolean;
    "isNotSerialized"?: boolean;
    "isPinvokeImpl"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "fieldHandle"?: RuntimeFieldHandle;
}

export interface FleetResponse {
    "id"?: number;
    "name"?: string;
    "pricingPlanTypeId"?: PricingPlanTypeEnum;
    "isActive"?: boolean;
}

export type FloLiveSubscriberStatusEnum = "Active" | "Suspend";

export type GenericParameterAttributes = "None" | "Covariant" | "Contravariant" | "VarianceMask" | "ReferenceTypeConstraint" | "NotNullableValueTypeConstraint" | "DefaultConstructorConstraint" | "SpecialConstraintMask" | "AllowByRefLike";

export interface GeotabUserSummaryResponse {
    "geotabUserId"?: string;
    "email"?: string;
}

export interface HealthCheckResponse {
}

export interface HealthCheckResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: HealthCheckResponse;
}

export interface ICustomAttributeProvider {
}

export interface IdentityUser {
    "id"?: string;
    "userName"?: string;
    "normalizedUserName"?: string;
    "email"?: string;
    "normalizedEmail"?: string;
    "emailConfirmed"?: boolean;
    "passwordHash"?: string;
    "securityStamp"?: string;
    "concurrencyStamp"?: string;
    "phoneNumber"?: string;
    "phoneNumberConfirmed"?: boolean;
    "twoFactorEnabled"?: boolean;
    "lockoutEnd"?: Date;
    "lockoutEnabled"?: boolean;
    "accessFailedCount"?: number;
}

export interface IntPtr {
}

export type LayoutKind = "Sequential" | "Explicit" | "Auto";

export interface LiveDeviceDetailsResponse {
    "totalCapacityMb"?: number;
    "firmwareVersion"?: string;
    "dataUsage"?: Array<DataUsageResponse>;
    "latitude"?: number;
    "longitude"?: number;
    "lastGpsTimestamp"?: Date;
    "earliestFootageDate"?: Date;
}

export interface Location {
    "latitude"?: number;
    "longitude"?: number;
}

export interface LoginUserRequest {
    "username"?: string;
    "password"?: string;
    "token"?: string;
}

export interface LookupResponse {
    "id"?: number;
    "displayName"?: string;
}

export interface MemberInfo {
    "memberType"?: MemberTypes;
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
}

export type MemberTypes = "Constructor" | "Event" | "Field" | "Method" | "Property" | "TypeInfo" | "Custom" | "NestedType" | "All";

export type MethodAttributes = "PrivateScope" | "ReuseSlot" | "Private" | "FamANDAssem" | "Assembly" | "Family" | "FamORAssem" | "Public" | "MemberAccessMask" | "UnmanagedExport" | "Static" | "Final" | "Virtual" | "HideBySig" | "NewSlot" | "VtableLayoutMask" | "CheckAccessOnOverride" | "Abstract" | "SpecialName" | "RTSpecialName" | "PinvokeImpl" | "HasSecurity" | "RequireSecObject" | "ReservedMask";

export interface MethodBase {
    "memberType"?: MemberTypes;
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "attributes"?: MethodAttributes;
    "methodImplementationFlags"?: MethodImplAttributes;
    "callingConvention"?: CallingConventions;
    "isAbstract"?: boolean;
    "isConstructor"?: boolean;
    "isFinal"?: boolean;
    "isHideBySig"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isVirtual"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isConstructedGenericMethod"?: boolean;
    "isGenericMethod"?: boolean;
    "isGenericMethodDefinition"?: boolean;
    "containsGenericParameters"?: boolean;
    "methodHandle"?: RuntimeMethodHandle;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
}

export type MethodImplAttributes = "IL" | "Managed" | "Native" | "OPTIL" | "CodeTypeMask" | "Runtime" | "ManagedMask" | "Unmanaged" | "NoInlining" | "ForwardRef" | "Synchronized" | "NoOptimization" | "PreserveSig" | "AggressiveInlining" | "AggressiveOptimization" | "InternalCall" | "Async" | "MaxMethodImplVal";

export interface MethodInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "attributes"?: MethodAttributes;
    "methodImplementationFlags"?: MethodImplAttributes;
    "callingConvention"?: CallingConventions;
    "isAbstract"?: boolean;
    "isConstructor"?: boolean;
    "isFinal"?: boolean;
    "isHideBySig"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isVirtual"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isConstructedGenericMethod"?: boolean;
    "isGenericMethod"?: boolean;
    "isGenericMethodDefinition"?: boolean;
    "containsGenericParameters"?: boolean;
    "methodHandle"?: RuntimeMethodHandle;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "memberType"?: MemberTypes;
    "returnParameter"?: ParameterInfo;
    "returnType"?: Type;
    "returnTypeCustomAttributes"?: ICustomAttributeProvider;
}

export interface Module {
    "assembly"?: Assembly;
    "fullyQualifiedName"?: string;
    "name"?: string;
    "mdStreamVersion"?: number;
    "moduleVersionId"?: string;
    "scopeName"?: string;
    "moduleHandle"?: ModuleHandle;
    "customAttributes"?: Array<CustomAttributeData>;
    "metadataToken"?: number;
}

export interface ModuleHandle {
    "mdStreamVersion"?: number;
}

export type ParameterAttributes = "None" | "In" | "Out" | "Lcid" | "Retval" | "Optional" | "HasDefault" | "HasFieldMarshal" | "Reserved3" | "Reserved4" | "ReservedMask";

export interface ParameterInfo {
    "attributes"?: ParameterAttributes;
    "member"?: MemberInfo;
    "name"?: string;
    "parameterType"?: Type;
    "position"?: number;
    "isIn"?: boolean;
    "isLcid"?: boolean;
    "isOptional"?: boolean;
    "isOut"?: boolean;
    "isRetval"?: boolean;
    "hasDefaultValue"?: boolean;
    "customAttributes"?: Array<CustomAttributeData>;
    "metadataToken"?: number;
}

export type PricingPlanTypeEnum = "Base" | "Pro" | "ProPlus";

export type PropertyAttributes = "None" | "SpecialName" | "RTSpecialName" | "HasDefault" | "Reserved2" | "Reserved3" | "Reserved4" | "ReservedMask";

export interface PropertyInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "propertyType"?: Type;
    "attributes"?: PropertyAttributes;
    "isSpecialName"?: boolean;
    "canRead"?: boolean;
    "canWrite"?: boolean;
    "getMethod"?: MethodInfo;
    "setMethod"?: MethodInfo;
}

export interface RuntimeFieldHandle {
    "value"?: IntPtr;
}

export interface RuntimeMethodHandle {
    "value"?: IntPtr;
}

export interface RuntimeTypeHandle {
    "value"?: IntPtr;
}

export type SecurityRuleSet = "None" | "Level1" | "Level2";

export interface SimStatusResponse {
    "iccid"?: string;
    "simStatus"?: string;
}

export interface SplitFeatureToggle {
    "featureToggle"?: string;
    "isSplitOn"?: boolean;
}

export interface SplitTreatmentOptions {
    "featureToggle"?: string;
    "attributes"?: any;
    "controlDefault"?: boolean;
}

export type StrikerStorageStateEnum = "NoStorage" | "Unformatted" | "BeingFormatted" | "NotMounted" | "Full" | "Normal" | "Recording" | "HardDiskReadWriteError" | "TestingHardDisk" | "PartitioningError";

export interface StructLayoutAttribute {
    "value"?: LayoutKind;
}

export interface SupportPortalAddSuperAdminRequest {
    "email"?: string;
    "geotabUserId"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "phoneNumber"?: string;
    "jobTitle"?: string;
}

export interface SupportPortalDeviceMoveAndCreateRequest {
    "userName"?: string;
    "cameraDeviceIds"?: Array<number>;
    "cgRootId"?: string;
    "companyId"?: string;
    "companyName"?: string;
}

export interface SupportPortalDeviceMoveRequest {
    "userName"?: string;
    "deviceUpdateFleetRequests"?: Array<DeviceFleetUpdate>;
}

export interface SupportPortalExportResponse {
    "fleets"?: Array<SupportalExportFleetResponse>;
    "devices"?: Array<SupportalExportDeviceResponse>;
}

export interface SupportPortalMoveDevicesResponse {
    /**
     * a list of cameras that were successfully moved
     */
    "successfulDeviceIds"?: Array<number>;
    /**
     * a list of cameras that were unsuccessfully moved
     */
    "unsuccessfulMoveDeviceResponses"?: Array<UnsuccessfulMoveDeviceResponse>;
    /**
     * Name of the fleet (Company Level in Encompass)
     */
    "newFleetName"?: string;
    /**
     * Id of the fleet within the VideoProtects system
     */
    "fleetId"?: number;
}

export interface SupportalExportDeviceResponse {
    "sourceDeviceId"?: number;
    "serialNumber"?: string;
    "deviceType"?: string;
    "iccid"?: string;
    "shipDate"?: Date;
    "sourceFleetId"?: number;
    "pairingUpdatedOn"?: Date;
    "firstEventDate"?: Date;
    "cameraDeviceChannels"?: Array<CameraDeviceChannelTypeEnum>;
    "pairedVehicle"?: SupportalExportVehicleResponse;
    "connectionStatus"?: CameraDeviceStateEnum;
    "sapStatus"?: CameraDeviceStatusEnum;
}

export interface SupportalExportFleetResponse {
    "sourceFleetId"?: number;
    "name"?: string;
    "cgRootId"?: string;
    "cgRootName"?: string;
    "isActive"?: boolean;
    "isInternal"?: boolean;
    "isVrs"?: boolean;
    "vrsActivationDate"?: Date;
    "vrsCancelDate"?: Date;
}

export interface SupportalExportVehicleResponse {
    "sourceVehicleId"?: number;
    "name"?: string;
    "telematicDeviceSerialNumber"?: string;
    "integrationPartnerDeviceId"?: string;
}

export interface TelematicDeviceAdminResponse {
    "sourceId"?: string;
    "name"?: string;
    "serialNumber"?: string;
    "type"?: string;
}

export interface TelematicDeviceResponse {
    "id"?: number;
    "serialNumber"?: string;
    "deviceId"?: string;
    "name"?: string;
    "type"?: string;
    "providerId"?: TelematicProviderIdEnum;
    "providerName"?: string;
    "location"?: string;
    "latitude"?: number;
    "longitude"?: number;
    "ignitionOn"?: boolean;
    "refreshDate"?: Date;
}

export type TelematicProviderIdEnum = "Geotab" | "Striker";

export interface TelematicsDeviceResponse {
    "id"?: number;
    "serialNumber"?: string;
    "deviceId"?: string;
    "name"?: string;
    "type"?: string;
    "provider"?: string;
    "location"?: string;
    "latitude"?: number;
    "longitude"?: number;
    "ignitionOn"?: boolean;
    "refreshDate"?: Date;
}

export interface Type {
    "name"?: string;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "namespace"?: string;
    "assemblyQualifiedName"?: string;
    "fullName"?: string;
    "assembly"?: Assembly;
    "module"?: Module;
    "isInterface"?: boolean;
    "isNested"?: boolean;
    "declaringType"?: Type;
    "declaringMethod"?: MethodBase;
    "reflectedType"?: Type;
    "underlyingSystemType"?: Type;
    "isTypeDefinition"?: boolean;
    "isArray"?: boolean;
    "isByRef"?: boolean;
    "isPointer"?: boolean;
    "isConstructedGenericType"?: boolean;
    "isGenericParameter"?: boolean;
    "isGenericTypeParameter"?: boolean;
    "isGenericMethodParameter"?: boolean;
    "isGenericType"?: boolean;
    "isGenericTypeDefinition"?: boolean;
    "isSZArray"?: boolean;
    "isVariableBoundArray"?: boolean;
    "isByRefLike"?: boolean;
    "isFunctionPointer"?: boolean;
    "isUnmanagedFunctionPointer"?: boolean;
    "hasElementType"?: boolean;
    "genericTypeArguments"?: Array<Type>;
    "genericParameterPosition"?: number;
    "genericParameterAttributes"?: GenericParameterAttributes;
    "attributes"?: TypeAttributes;
    "isAbstract"?: boolean;
    "isImport"?: boolean;
    "isSealed"?: boolean;
    "isSpecialName"?: boolean;
    "isClass"?: boolean;
    "isNestedAssembly"?: boolean;
    "isNestedFamANDAssem"?: boolean;
    "isNestedFamily"?: boolean;
    "isNestedFamORAssem"?: boolean;
    "isNestedPrivate"?: boolean;
    "isNestedPublic"?: boolean;
    "isNotPublic"?: boolean;
    "isPublic"?: boolean;
    "isAutoLayout"?: boolean;
    "isExplicitLayout"?: boolean;
    "isLayoutSequential"?: boolean;
    "isAnsiClass"?: boolean;
    "isAutoClass"?: boolean;
    "isUnicodeClass"?: boolean;
    "isCOMObject"?: boolean;
    "isContextful"?: boolean;
    "isEnum"?: boolean;
    "isMarshalByRef"?: boolean;
    "isPrimitive"?: boolean;
    "isValueType"?: boolean;
    "isSignatureType"?: boolean;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "structLayoutAttribute"?: StructLayoutAttribute;
    "typeInitializer"?: ConstructorInfo;
    "typeHandle"?: RuntimeTypeHandle;
    "guid"?: string;
    "baseType"?: Type;
    "isSerializable"?: boolean;
    "containsGenericParameters"?: boolean;
    "isVisible"?: boolean;
}

export type TypeAttributes = "NotPublic" | "AutoLayout" | "AnsiClass" | "Class" | "Public" | "NestedPublic" | "NestedPrivate" | "NestedFamily" | "NestedAssembly" | "NestedFamANDAssem" | "VisibilityMask" | "NestedFamORAssem" | "SequentialLayout" | "ExplicitLayout" | "LayoutMask" | "Interface" | "ClassSemanticsMask" | "Abstract" | "Sealed" | "SpecialName" | "RTSpecialName" | "Import" | "Serializable" | "WindowsRuntime" | "UnicodeClass" | "AutoClass" | "StringFormatMask" | "CustomFormatClass" | "HasSecurity" | "ReservedMask" | "BeforeFieldInit" | "CustomFormatMask";

export interface TypeInfo {
    "name"?: string;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "namespace"?: string;
    "assemblyQualifiedName"?: string;
    "fullName"?: string;
    "assembly"?: Assembly;
    "module"?: Module;
    "isInterface"?: boolean;
    "isNested"?: boolean;
    "declaringType"?: Type;
    "declaringMethod"?: MethodBase;
    "reflectedType"?: Type;
    "underlyingSystemType"?: Type;
    "isTypeDefinition"?: boolean;
    "isArray"?: boolean;
    "isByRef"?: boolean;
    "isPointer"?: boolean;
    "isConstructedGenericType"?: boolean;
    "isGenericParameter"?: boolean;
    "isGenericTypeParameter"?: boolean;
    "isGenericMethodParameter"?: boolean;
    "isGenericType"?: boolean;
    "isGenericTypeDefinition"?: boolean;
    "isSZArray"?: boolean;
    "isVariableBoundArray"?: boolean;
    "isByRefLike"?: boolean;
    "isFunctionPointer"?: boolean;
    "isUnmanagedFunctionPointer"?: boolean;
    "hasElementType"?: boolean;
    "genericTypeArguments"?: Array<Type>;
    "genericParameterPosition"?: number;
    "genericParameterAttributes"?: GenericParameterAttributes;
    "attributes"?: TypeAttributes;
    "isAbstract"?: boolean;
    "isImport"?: boolean;
    "isSealed"?: boolean;
    "isSpecialName"?: boolean;
    "isClass"?: boolean;
    "isNestedAssembly"?: boolean;
    "isNestedFamANDAssem"?: boolean;
    "isNestedFamily"?: boolean;
    "isNestedFamORAssem"?: boolean;
    "isNestedPrivate"?: boolean;
    "isNestedPublic"?: boolean;
    "isNotPublic"?: boolean;
    "isPublic"?: boolean;
    "isAutoLayout"?: boolean;
    "isExplicitLayout"?: boolean;
    "isLayoutSequential"?: boolean;
    "isAnsiClass"?: boolean;
    "isAutoClass"?: boolean;
    "isUnicodeClass"?: boolean;
    "isCOMObject"?: boolean;
    "isContextful"?: boolean;
    "isEnum"?: boolean;
    "isMarshalByRef"?: boolean;
    "isPrimitive"?: boolean;
    "isValueType"?: boolean;
    "isSignatureType"?: boolean;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "structLayoutAttribute"?: StructLayoutAttribute;
    "typeInitializer"?: ConstructorInfo;
    "typeHandle"?: RuntimeTypeHandle;
    "guid"?: string;
    "baseType"?: Type;
    "isSerializable"?: boolean;
    "containsGenericParameters"?: boolean;
    "isVisible"?: boolean;
    "genericTypeParameters"?: Array<Type>;
    "declaredConstructors"?: Array<ConstructorInfo>;
    "declaredEvents"?: Array<EventInfo>;
    "declaredFields"?: Array<FieldInfo>;
    "declaredMembers"?: Array<MemberInfo>;
    "declaredMethods"?: Array<MethodInfo>;
    "declaredNestedTypes"?: Array<TypeInfo>;
    "declaredProperties"?: Array<PropertyInfo>;
    "implementedInterfaces"?: Array<Type>;
}

export interface UnpairRequest {
    "cameraDeviceId"?: number;
}

export interface UnpairResponse {
    "cameraDeviceId"?: number;
    "endDate"?: Date;
}

export interface UnsuccessfulMoveDeviceResponse {
    /**
     * the id of the camera unable to be moved
     */
    "deviceId"?: number;
    /**
     * the rationale behind the issue
     */
    "errorMessage"?: string;
}

export interface UpdateCameraDevicesVideoDisabledRequest {
    "cameraDeviceIds"?: Array<number>;
    "videoDisabled"?: boolean;
}

export interface UpdateDeviceIccidRequest {
    "deviceId"?: number;
    "iccid": string;
}

export interface UpdateDeviceSimCardStatesRequest {
    "status"?: FloLiveSubscriberStatusEnum;
    "deviceIds"?: Array<number>;
}

export interface UpdateUserRequest {
    "id": string;
    "userName": string;
    "firstName": string;
    "lastName": string;
    "email": string;
    "role": string;
}

export interface UserResponse {
    "firstName"?: string;
    "lastName"?: string;
    "email"?: string;
    "roles"?: Array<string>;
}

export interface VehicleCameraPairingResponse {
    "id"?: number;
    "cameraId"?: number;
    "isGpsTrackingEnabled"?: boolean;
    "fleetId"?: number;
    "clientName"?: string;
    "startDate"?: Date;
    "endDate"?: Date;
    "camera"?: CameraDeviceResponse;
    "vehicle"?: VehicleResponse;
}

export interface VehicleResponse {
    "id"?: number;
    "name"?: string;
    "vin"?: string;
    "integrationPartnerVehicleId"?: string;
    "fleetId"?: number;
    "telematicDevice"?: TelematicDeviceResponse;
    "companyLevelId"?: string;
    "companyLevelName"?: string;
}



/**
 * AgreementsApi - fetch parameter creator
 */
export const AgreementsApiFetchParamCreator = {
    /** 
     * @param body 
     */
    apiV1AgreementsAgreementVersionPost(params: {  "body"?: AddAgreementVersionRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/agreements/agreement-version`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * AgreementsApi - functional programming interface
 */
export const AgreementsApiFp = {
    /** 
     * @param body 
     */
    apiV1AgreementsAgreementVersionPost(params: { "body"?: AddAgreementVersionRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AgreementsApiFetchParamCreator.apiV1AgreementsAgreementVersionPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * AgreementsApi - object-oriented interface
 */
export class AgreementsApi extends BaseAPI {
    /** 
     * @param body 
     */
    apiV1AgreementsAgreementVersionPost(params: {  "body"?: AddAgreementVersionRequest; }, options?: any) {
        return AgreementsApiFp.apiV1AgreementsAgreementVersionPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * AgreementsApi - factory interface
 */
export const AgreementsApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param body 
         */
        apiV1AgreementsAgreementVersionPost(params: {  "body"?: AddAgreementVersionRequest; }, options?: any) {
            return AgreementsApiFp.apiV1AgreementsAgreementVersionPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * AutomatedTestApi - fetch parameter creator
 */
export const AutomatedTestApiFetchParamCreator = {
    /** 
     * @param serialNumber 
     */
    apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params: {  "serialNumber": string; }, options?: any): FetchArgs {
        // verify required parameter "serialNumber" is set
        if (params["serialNumber"] == null) {
            throw new Error("Missing required parameter serialNumber when calling apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut");
        }
        const baseUrl = `/api/v1/AutomatedTest/add-camera-to-environment-tenant/{serialNumber}`
            .replace(`{${"serialNumber"}}`, `${ params["serialNumber"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param email 
     */
    apiV1AutomatedTestInstallerEmailDelete(params: {  "email": string; }, options?: any): FetchArgs {
        // verify required parameter "email" is set
        if (params["email"] == null) {
            throw new Error("Missing required parameter email when calling apiV1AutomatedTestInstallerEmailDelete");
        }
        const baseUrl = `/api/v1/AutomatedTest/installer/{email}`
            .replace(`{${"email"}}`, `${ params["email"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param serialNumber 
     */
    apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params: {  "serialNumber": string; }, options?: any): FetchArgs {
        // verify required parameter "serialNumber" is set
        if (params["serialNumber"] == null) {
            throw new Error("Missing required parameter serialNumber when calling apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut");
        }
        const baseUrl = `/api/v1/AutomatedTest/return-camera-to-landing-tenant/{serialNumber}`
            .replace(`{${"serialNumber"}}`, `${ params["serialNumber"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * AutomatedTestApi - functional programming interface
 */
export const AutomatedTestApiFp = {
    /** 
     * @param serialNumber 
     */
    apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params: { "serialNumber": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AutomatedTestApiFetchParamCreator.apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param email 
     */
    apiV1AutomatedTestInstallerEmailDelete(params: { "email": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AutomatedTestApiFetchParamCreator.apiV1AutomatedTestInstallerEmailDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param serialNumber 
     */
    apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params: { "serialNumber": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AutomatedTestApiFetchParamCreator.apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * AutomatedTestApi - object-oriented interface
 */
export class AutomatedTestApi extends BaseAPI {
    /** 
     * @param serialNumber 
     */
    apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params: {  "serialNumber": string; }, options?: any) {
        return AutomatedTestApiFp.apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param email 
     */
    apiV1AutomatedTestInstallerEmailDelete(params: {  "email": string; }, options?: any) {
        return AutomatedTestApiFp.apiV1AutomatedTestInstallerEmailDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param serialNumber 
     */
    apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params: {  "serialNumber": string; }, options?: any) {
        return AutomatedTestApiFp.apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params, options)(this.fetch, this.basePath);
    }
};

/**
 * AutomatedTestApi - factory interface
 */
export const AutomatedTestApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param serialNumber 
         */
        apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params: {  "serialNumber": string; }, options?: any) {
            return AutomatedTestApiFp.apiV1AutomatedTestAddCameraToEnvironmentTenantSerialNumberPut(params, options)(fetch, basePath);
        },
        /** 
         * @param email 
         */
        apiV1AutomatedTestInstallerEmailDelete(params: {  "email": string; }, options?: any) {
            return AutomatedTestApiFp.apiV1AutomatedTestInstallerEmailDelete(params, options)(fetch, basePath);
        },
        /** 
         * @param serialNumber 
         */
        apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params: {  "serialNumber": string; }, options?: any) {
            return AutomatedTestApiFp.apiV1AutomatedTestReturnCameraToLandingTenantSerialNumberPut(params, options)(fetch, basePath);
        },
    };
};


/**
 * ConfigApi - fetch parameter creator
 */
export const ConfigApiFetchParamCreator = {
    /** 
     */
    apiV1ConfigGetClientConfigGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/config/getClientConfig`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * ConfigApi - functional programming interface
 */
export const ConfigApiFp = {
    /** 
     */
    apiV1ConfigGetClientConfigGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ClientConfigResponse> {
        const fetchArgs = ConfigApiFetchParamCreator.apiV1ConfigGetClientConfigGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * ConfigApi - object-oriented interface
 */
export class ConfigApi extends BaseAPI {
    /** 
     */
    apiV1ConfigGetClientConfigGet(options?: any) {
        return ConfigApiFp.apiV1ConfigGetClientConfigGet(options)(this.fetch, this.basePath);
    }
};

/**
 * ConfigApi - factory interface
 */
export const ConfigApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         */
        apiV1ConfigGetClientConfigGet(options?: any) {
            return ConfigApiFp.apiV1ConfigGetClientConfigGet(options)(fetch, basePath);
        },
    };
};


/**
 * CryptographyApi - fetch parameter creator
 */
export const CryptographyApiFetchParamCreator = {
    /** 
     * @param data 
     */
    decryptdatabaserecordGet(params: {  "data"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/decryptdatabaserecord`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "data": params["data"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param data 
     */
    encryptdatabaserecordPost(params: {  "data"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/encryptdatabaserecord`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "data": params["data"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * CryptographyApi - functional programming interface
 */
export const CryptographyApiFp = {
    /** 
     * @param data 
     */
    decryptdatabaserecordGet(params: { "data"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = CryptographyApiFetchParamCreator.decryptdatabaserecordGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param data 
     */
    encryptdatabaserecordPost(params: { "data"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = CryptographyApiFetchParamCreator.encryptdatabaserecordPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * CryptographyApi - object-oriented interface
 */
export class CryptographyApi extends BaseAPI {
    /** 
     * @param data 
     */
    decryptdatabaserecordGet(params: {  "data"?: string; }, options?: any) {
        return CryptographyApiFp.decryptdatabaserecordGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param data 
     */
    encryptdatabaserecordPost(params: {  "data"?: string; }, options?: any) {
        return CryptographyApiFp.encryptdatabaserecordPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * CryptographyApi - factory interface
 */
export const CryptographyApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param data 
         */
        decryptdatabaserecordGet(params: {  "data"?: string; }, options?: any) {
            return CryptographyApiFp.decryptdatabaserecordGet(params, options)(fetch, basePath);
        },
        /** 
         * @param data 
         */
        encryptdatabaserecordPost(params: {  "data"?: string; }, options?: any) {
            return CryptographyApiFp.encryptdatabaserecordPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * DeviceManagementApi - fetch parameter creator
 */
export const DeviceManagementApiFetchParamCreator = {
    /** 
     * activates Camera
     * @param id camera id
     */
    apiV1ActivatecameraPost(params: {  "id"?: number; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/activatecamera`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param fleetId 
     * @param cameraId 
     */
    apiV1CameraAssociationGet(params: {  "fleetId"?: number; "cameraId"?: number; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/cameraAssociation`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "fleetId": params["fleetId"],
            "cameraId": params["cameraId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     */
    apiV1CameratypesGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/cameratypes`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets the filter data for the device history grid
     */
    apiV1DeviceHistoryFiltersGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceHistory/filters`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get History of a particular device pairing
     * @param id 
     * @param sortBy 
     * @param sortAsc 
     * @param actionFilter 
     */
    apiV1DeviceHistoryGet(params: {  "id"?: number; "sortBy"?: string; "sortAsc"?: boolean; "actionFilter"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceHistory`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
            "sortBy": params["sortBy"],
            "sortAsc": params["sortAsc"],
            "actionFilter": params["actionFilter"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1DeviceassociationBatchDevicesPost(params: {  "body"?: Array<string>; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceassociation/batchDevices`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets the fleet information for a camera.
     * @param cameraSerialNumber Camera serialnumber
     */
    apiV1DeviceassociationCameraFleetGet(params: {  "cameraSerialNumber"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceassociation/cameraFleet`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "cameraSerialNumber": params["cameraSerialNumber"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets the fleet information for a company.
     * @param companyId Company unique Id
     */
    apiV1DeviceassociationCompanyFleetGet(params: {  "companyId"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceassociation/companyFleet`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "companyId": params["companyId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1DeviceassociationPost(params: {  "body"?: CreatePairingRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceassociation`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Updates the fleet setting for a list of cameras.  Cameras will be unpared after moving
     * @param body request to update multiple cameras to a new fleet
     */
    apiV1DeviceassociationUpdateCameraFleetPost(params: {  "body"?: BulkUpdateFleetRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceassociation/updateCameraFleet`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets the filter data for the device management page
     */
    apiV1DeviceassociationsFiltersGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/deviceassociations/filters`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all information for a particular pairing
     * @param id 
     */
    apiV1DevicedetailsGet(params: {  "id"?: number; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/devicedetails`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get All Device Camera Pairings
     * @param fleetIds 
     * @param deviceTypes 
     * @param deviceStatuses 
     * @param currentPage 
     * @param itemsPerPage 
     * @param sortBy 
     * @param sortAsc 
     * @param search 
     */
    apiV1DevicesGet(params: {  "fleetIds"?: Array<number>; "deviceTypes"?: Array<number>; "deviceStatuses"?: Array<string>; "currentPage"?: number; "itemsPerPage"?: number; "sortBy"?: string; "sortAsc"?: boolean; "search"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/devices`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "fleetIds": params["fleetIds"],
            "deviceTypes": params["deviceTypes"],
            "deviceStatuses": params["deviceStatuses"],
            "currentPage": params["currentPage"],
            "itemsPerPage": params["itemsPerPage"],
            "sortBy": params["sortBy"],
            "sortAsc": params["sortAsc"],
            "search": params["search"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get data usage by iccid
     * @param iccid 
     */
    apiV1IndividualdatausageGet(params: {  "iccid"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/individualdatausage`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "iccid": params["iccid"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param fleetId 
     * @param cameraDeviceType 
     * @param searchString 
     */
    apiV1SearchcamerasGet(params: {  "fleetId"?: number; "cameraDeviceType"?: number; "searchString"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/searchcameras`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "fleetId": params["fleetId"],
            "cameraDeviceType": params["cameraDeviceType"],
            "searchString": params["searchString"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Suspends Camera
     * @param id camera id
     */
    apiV1SuspendcameraPost(params: {  "id"?: number; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/suspendcamera`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param fleetId 
     * @param telematicProviderId 
     * @param telematicDeviceId 
     */
    apiV1TelematicDeviceAssociationGet(params: {  "fleetId"?: number; "telematicProviderId"?: string; "telematicDeviceId"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/telematicDeviceAssociation`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "fleetId": params["fleetId"],
            "telematicProviderId": params["telematicProviderId"],
            "telematicDeviceId": params["telematicDeviceId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * DeviceManagementApi - functional programming interface
 */
export const DeviceManagementApiFp = {
    /** 
     * activates Camera
     * @param id camera id
     */
    apiV1ActivatecameraPost(params: { "id"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1ActivatecameraPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param fleetId 
     * @param cameraId 
     */
    apiV1CameraAssociationGet(params: { "fleetId"?: number; "cameraId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeviceAssociationValidationResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1CameraAssociationGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     */
    apiV1CameratypesGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LookupResponse>> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1CameratypesGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets the filter data for the device history grid
     */
    apiV1DeviceHistoryFiltersGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DropdownMenuItem>> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceHistoryFiltersGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get History of a particular device pairing
     * @param id 
     * @param sortBy 
     * @param sortAsc 
     * @param actionFilter 
     */
    apiV1DeviceHistoryGet(params: { "id"?: number; "sortBy"?: string; "sortAsc"?: boolean; "actionFilter"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DeviceHistoryResponse>> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceHistoryGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1DeviceassociationBatchDevicesPost(params: { "body"?: Array<string>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeviceBatchResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceassociationBatchDevicesPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets the fleet information for a camera.
     * @param cameraSerialNumber Camera serialnumber
     */
    apiV1DeviceassociationCameraFleetGet(params: { "cameraSerialNumber"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FleetResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceassociationCameraFleetGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets the fleet information for a company.
     * @param companyId Company unique Id
     */
    apiV1DeviceassociationCompanyFleetGet(params: { "companyId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FleetResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceassociationCompanyFleetGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1DeviceassociationPost(params: { "body"?: CreatePairingRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceassociationPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Updates the fleet setting for a list of cameras.  Cameras will be unpared after moving
     * @param body request to update multiple cameras to a new fleet
     */
    apiV1DeviceassociationUpdateCameraFleetPost(params: { "body"?: BulkUpdateFleetRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceassociationUpdateCameraFleetPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets the filter data for the device management page
     */
    apiV1DeviceassociationsFiltersGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeviceManagementFilterDataResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DeviceassociationsFiltersGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all information for a particular pairing
     * @param id 
     */
    apiV1DevicedetailsGet(params: { "id"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CameraDeviceResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DevicedetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get All Device Camera Pairings
     * @param fleetIds 
     * @param deviceTypes 
     * @param deviceStatuses 
     * @param currentPage 
     * @param itemsPerPage 
     * @param sortBy 
     * @param sortAsc 
     * @param search 
     */
    apiV1DevicesGet(params: { "fleetIds"?: Array<number>; "deviceTypes"?: Array<number>; "deviceStatuses"?: Array<string>; "currentPage"?: number; "itemsPerPage"?: number; "sortBy"?: string; "sortAsc"?: boolean; "search"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeviceHealthResponseIEnumerablePagedResponseBase> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1DevicesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get data usage by iccid
     * @param iccid 
     */
    apiV1IndividualdatausageGet(params: { "iccid"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DataUsageResponse>> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1IndividualdatausageGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param fleetId 
     * @param cameraDeviceType 
     * @param searchString 
     */
    apiV1SearchcamerasGet(params: { "fleetId"?: number; "cameraDeviceType"?: number; "searchString"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CameraResponse>> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1SearchcamerasGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Suspends Camera
     * @param id camera id
     */
    apiV1SuspendcameraPost(params: { "id"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1SuspendcameraPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param fleetId 
     * @param telematicProviderId 
     * @param telematicDeviceId 
     */
    apiV1TelematicDeviceAssociationGet(params: { "fleetId"?: number; "telematicProviderId"?: string; "telematicDeviceId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeviceAssociationValidationResponse> {
        const fetchArgs = DeviceManagementApiFetchParamCreator.apiV1TelematicDeviceAssociationGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * DeviceManagementApi - object-oriented interface
 */
export class DeviceManagementApi extends BaseAPI {
    /** 
     * activates Camera
     * @param id camera id
     */
    apiV1ActivatecameraPost(params: {  "id"?: number; }, options?: any) {
        return DeviceManagementApiFp.apiV1ActivatecameraPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param fleetId 
     * @param cameraId 
     */
    apiV1CameraAssociationGet(params: {  "fleetId"?: number; "cameraId"?: number; }, options?: any) {
        return DeviceManagementApiFp.apiV1CameraAssociationGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     */
    apiV1CameratypesGet(options?: any) {
        return DeviceManagementApiFp.apiV1CameratypesGet(options)(this.fetch, this.basePath);
    }
    /** 
     * Gets the filter data for the device history grid
     */
    apiV1DeviceHistoryFiltersGet(options?: any) {
        return DeviceManagementApiFp.apiV1DeviceHistoryFiltersGet(options)(this.fetch, this.basePath);
    }
    /** 
     * Get History of a particular device pairing
     * @param id 
     * @param sortBy 
     * @param sortAsc 
     * @param actionFilter 
     */
    apiV1DeviceHistoryGet(params: {  "id"?: number; "sortBy"?: string; "sortAsc"?: boolean; "actionFilter"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1DeviceHistoryGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1DeviceassociationBatchDevicesPost(params: {  "body"?: Array<string>; }, options?: any) {
        return DeviceManagementApiFp.apiV1DeviceassociationBatchDevicesPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Gets the fleet information for a camera.
     * @param cameraSerialNumber Camera serialnumber
     */
    apiV1DeviceassociationCameraFleetGet(params: {  "cameraSerialNumber"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1DeviceassociationCameraFleetGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Gets the fleet information for a company.
     * @param companyId Company unique Id
     */
    apiV1DeviceassociationCompanyFleetGet(params: {  "companyId"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1DeviceassociationCompanyFleetGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1DeviceassociationPost(params: {  "body"?: CreatePairingRequest; }, options?: any) {
        return DeviceManagementApiFp.apiV1DeviceassociationPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Updates the fleet setting for a list of cameras.  Cameras will be unpared after moving
     * @param body request to update multiple cameras to a new fleet
     */
    apiV1DeviceassociationUpdateCameraFleetPost(params: {  "body"?: BulkUpdateFleetRequest; }, options?: any) {
        return DeviceManagementApiFp.apiV1DeviceassociationUpdateCameraFleetPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Gets the filter data for the device management page
     */
    apiV1DeviceassociationsFiltersGet(options?: any) {
        return DeviceManagementApiFp.apiV1DeviceassociationsFiltersGet(options)(this.fetch, this.basePath);
    }
    /** 
     * Get all information for a particular pairing
     * @param id 
     */
    apiV1DevicedetailsGet(params: {  "id"?: number; }, options?: any) {
        return DeviceManagementApiFp.apiV1DevicedetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get All Device Camera Pairings
     * @param fleetIds 
     * @param deviceTypes 
     * @param deviceStatuses 
     * @param currentPage 
     * @param itemsPerPage 
     * @param sortBy 
     * @param sortAsc 
     * @param search 
     */
    apiV1DevicesGet(params: {  "fleetIds"?: Array<number>; "deviceTypes"?: Array<number>; "deviceStatuses"?: Array<string>; "currentPage"?: number; "itemsPerPage"?: number; "sortBy"?: string; "sortAsc"?: boolean; "search"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1DevicesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get data usage by iccid
     * @param iccid 
     */
    apiV1IndividualdatausageGet(params: {  "iccid"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1IndividualdatausageGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param fleetId 
     * @param cameraDeviceType 
     * @param searchString 
     */
    apiV1SearchcamerasGet(params: {  "fleetId"?: number; "cameraDeviceType"?: number; "searchString"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1SearchcamerasGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Suspends Camera
     * @param id camera id
     */
    apiV1SuspendcameraPost(params: {  "id"?: number; }, options?: any) {
        return DeviceManagementApiFp.apiV1SuspendcameraPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param fleetId 
     * @param telematicProviderId 
     * @param telematicDeviceId 
     */
    apiV1TelematicDeviceAssociationGet(params: {  "fleetId"?: number; "telematicProviderId"?: string; "telematicDeviceId"?: string; }, options?: any) {
        return DeviceManagementApiFp.apiV1TelematicDeviceAssociationGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * DeviceManagementApi - factory interface
 */
export const DeviceManagementApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * activates Camera
         * @param id camera id
         */
        apiV1ActivatecameraPost(params: {  "id"?: number; }, options?: any) {
            return DeviceManagementApiFp.apiV1ActivatecameraPost(params, options)(fetch, basePath);
        },
        /** 
         * @param fleetId 
         * @param cameraId 
         */
        apiV1CameraAssociationGet(params: {  "fleetId"?: number; "cameraId"?: number; }, options?: any) {
            return DeviceManagementApiFp.apiV1CameraAssociationGet(params, options)(fetch, basePath);
        },
        /** 
         */
        apiV1CameratypesGet(options?: any) {
            return DeviceManagementApiFp.apiV1CameratypesGet(options)(fetch, basePath);
        },
        /** 
         * Gets the filter data for the device history grid
         */
        apiV1DeviceHistoryFiltersGet(options?: any) {
            return DeviceManagementApiFp.apiV1DeviceHistoryFiltersGet(options)(fetch, basePath);
        },
        /** 
         * Get History of a particular device pairing
         * @param id 
         * @param sortBy 
         * @param sortAsc 
         * @param actionFilter 
         */
        apiV1DeviceHistoryGet(params: {  "id"?: number; "sortBy"?: string; "sortAsc"?: boolean; "actionFilter"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1DeviceHistoryGet(params, options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1DeviceassociationBatchDevicesPost(params: {  "body"?: Array<string>; }, options?: any) {
            return DeviceManagementApiFp.apiV1DeviceassociationBatchDevicesPost(params, options)(fetch, basePath);
        },
        /** 
         * Gets the fleet information for a camera.
         * @param cameraSerialNumber Camera serialnumber
         */
        apiV1DeviceassociationCameraFleetGet(params: {  "cameraSerialNumber"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1DeviceassociationCameraFleetGet(params, options)(fetch, basePath);
        },
        /** 
         * Gets the fleet information for a company.
         * @param companyId Company unique Id
         */
        apiV1DeviceassociationCompanyFleetGet(params: {  "companyId"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1DeviceassociationCompanyFleetGet(params, options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1DeviceassociationPost(params: {  "body"?: CreatePairingRequest; }, options?: any) {
            return DeviceManagementApiFp.apiV1DeviceassociationPost(params, options)(fetch, basePath);
        },
        /** 
         * Updates the fleet setting for a list of cameras.  Cameras will be unpared after moving
         * @param body request to update multiple cameras to a new fleet
         */
        apiV1DeviceassociationUpdateCameraFleetPost(params: {  "body"?: BulkUpdateFleetRequest; }, options?: any) {
            return DeviceManagementApiFp.apiV1DeviceassociationUpdateCameraFleetPost(params, options)(fetch, basePath);
        },
        /** 
         * Gets the filter data for the device management page
         */
        apiV1DeviceassociationsFiltersGet(options?: any) {
            return DeviceManagementApiFp.apiV1DeviceassociationsFiltersGet(options)(fetch, basePath);
        },
        /** 
         * Get all information for a particular pairing
         * @param id 
         */
        apiV1DevicedetailsGet(params: {  "id"?: number; }, options?: any) {
            return DeviceManagementApiFp.apiV1DevicedetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Get All Device Camera Pairings
         * @param fleetIds 
         * @param deviceTypes 
         * @param deviceStatuses 
         * @param currentPage 
         * @param itemsPerPage 
         * @param sortBy 
         * @param sortAsc 
         * @param search 
         */
        apiV1DevicesGet(params: {  "fleetIds"?: Array<number>; "deviceTypes"?: Array<number>; "deviceStatuses"?: Array<string>; "currentPage"?: number; "itemsPerPage"?: number; "sortBy"?: string; "sortAsc"?: boolean; "search"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1DevicesGet(params, options)(fetch, basePath);
        },
        /** 
         * Get data usage by iccid
         * @param iccid 
         */
        apiV1IndividualdatausageGet(params: {  "iccid"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1IndividualdatausageGet(params, options)(fetch, basePath);
        },
        /** 
         * @param fleetId 
         * @param cameraDeviceType 
         * @param searchString 
         */
        apiV1SearchcamerasGet(params: {  "fleetId"?: number; "cameraDeviceType"?: number; "searchString"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1SearchcamerasGet(params, options)(fetch, basePath);
        },
        /** 
         * Suspends Camera
         * @param id camera id
         */
        apiV1SuspendcameraPost(params: {  "id"?: number; }, options?: any) {
            return DeviceManagementApiFp.apiV1SuspendcameraPost(params, options)(fetch, basePath);
        },
        /** 
         * @param fleetId 
         * @param telematicProviderId 
         * @param telematicDeviceId 
         */
        apiV1TelematicDeviceAssociationGet(params: {  "fleetId"?: number; "telematicProviderId"?: string; "telematicDeviceId"?: string; }, options?: any) {
            return DeviceManagementApiFp.apiV1TelematicDeviceAssociationGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * FleetApi - fetch parameter creator
 */
export const FleetApiFetchParamCreator = {
    /** 
     */
    apiV1FleetsGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/fleets`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     */
    apiV1TelematicprovidersGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/telematicproviders`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * FleetApi - functional programming interface
 */
export const FleetApiFp = {
    /** 
     */
    apiV1FleetsGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LookupResponse>> {
        const fetchArgs = FleetApiFetchParamCreator.apiV1FleetsGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     */
    apiV1TelematicprovidersGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LookupResponse>> {
        const fetchArgs = FleetApiFetchParamCreator.apiV1TelematicprovidersGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * FleetApi - object-oriented interface
 */
export class FleetApi extends BaseAPI {
    /** 
     */
    apiV1FleetsGet(options?: any) {
        return FleetApiFp.apiV1FleetsGet(options)(this.fetch, this.basePath);
    }
    /** 
     */
    apiV1TelematicprovidersGet(options?: any) {
        return FleetApiFp.apiV1TelematicprovidersGet(options)(this.fetch, this.basePath);
    }
};

/**
 * FleetApi - factory interface
 */
export const FleetApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         */
        apiV1FleetsGet(options?: any) {
            return FleetApiFp.apiV1FleetsGet(options)(fetch, basePath);
        },
        /** 
         */
        apiV1TelematicprovidersGet(options?: any) {
            return FleetApiFp.apiV1TelematicprovidersGet(options)(fetch, basePath);
        },
    };
};


/**
 * HealthyApi - fetch parameter creator
 */
export const HealthyApiFetchParamCreator = {
    /** 
     * Create an empty response to allow external actors to verify if application is online
     */
    apiV1HealthAdminuiGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/health/adminui`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * HealthyApi - functional programming interface
 */
export const HealthyApiFp = {
    /** 
     * Create an empty response to allow external actors to verify if application is online
     */
    apiV1HealthAdminuiGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<HealthCheckResponseResponseBase> {
        const fetchArgs = HealthyApiFetchParamCreator.apiV1HealthAdminuiGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * HealthyApi - object-oriented interface
 */
export class HealthyApi extends BaseAPI {
    /** 
     * Create an empty response to allow external actors to verify if application is online
     */
    apiV1HealthAdminuiGet(options?: any) {
        return HealthyApiFp.apiV1HealthAdminuiGet(options)(this.fetch, this.basePath);
    }
};

/**
 * HealthyApi - factory interface
 */
export const HealthyApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Create an empty response to allow external actors to verify if application is online
         */
        apiV1HealthAdminuiGet(options?: any) {
            return HealthyApiFp.apiV1HealthAdminuiGet(options)(fetch, basePath);
        },
    };
};


/**
 * IdentityApi - fetch parameter creator
 */
export const IdentityApiFetchParamCreator = {
    /** 
     * @param body 
     */
    apiV1AddUserPost(params: {  "body"?: CreateUserRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/addUser`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     */
    apiV1CurrentUserGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/currentUser`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1DeleteUserPost(params: {  "body"?: IdentityUser; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/deleteUser`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1ForgetPasswordPost(params: {  "body"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/forgetPassword`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     */
    apiV1GetUsersGet(options?: any): FetchArgs {
        const baseUrl = `/api/v1/getUsers`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1LoginPost(params: {  "body"?: LoginUserRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/login`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     */
    apiV1LogoutPost(options?: any): FetchArgs {
        const baseUrl = `/api/v1/logout`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1ResetPasswordPost(params: {  "body"?: LoginUserRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/resetPassword`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param body 
     */
    apiV1UpdateUserPost(params: {  "body"?: UpdateUserRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/updateUser`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * IdentityApi - functional programming interface
 */
export const IdentityApiFp = {
    /** 
     * @param body 
     */
    apiV1AddUserPost(params: { "body"?: CreateUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1AddUserPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     */
    apiV1CurrentUserGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserResponse> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1CurrentUserGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1DeleteUserPost(params: { "body"?: IdentityUser;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1DeleteUserPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1ForgetPasswordPost(params: { "body"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1ForgetPasswordPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     */
    apiV1GetUsersGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdminUserResponse>> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1GetUsersGet(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1LoginPost(params: { "body"?: LoginUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1LoginPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     */
    apiV1LogoutPost(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1LogoutPost(options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1ResetPasswordPost(params: { "body"?: LoginUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1ResetPasswordPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param body 
     */
    apiV1UpdateUserPost(params: { "body"?: UpdateUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = IdentityApiFetchParamCreator.apiV1UpdateUserPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * IdentityApi - object-oriented interface
 */
export class IdentityApi extends BaseAPI {
    /** 
     * @param body 
     */
    apiV1AddUserPost(params: {  "body"?: CreateUserRequest; }, options?: any) {
        return IdentityApiFp.apiV1AddUserPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     */
    apiV1CurrentUserGet(options?: any) {
        return IdentityApiFp.apiV1CurrentUserGet(options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1DeleteUserPost(params: {  "body"?: IdentityUser; }, options?: any) {
        return IdentityApiFp.apiV1DeleteUserPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1ForgetPasswordPost(params: {  "body"?: string; }, options?: any) {
        return IdentityApiFp.apiV1ForgetPasswordPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     */
    apiV1GetUsersGet(options?: any) {
        return IdentityApiFp.apiV1GetUsersGet(options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1LoginPost(params: {  "body"?: LoginUserRequest; }, options?: any) {
        return IdentityApiFp.apiV1LoginPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     */
    apiV1LogoutPost(options?: any) {
        return IdentityApiFp.apiV1LogoutPost(options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1ResetPasswordPost(params: {  "body"?: LoginUserRequest; }, options?: any) {
        return IdentityApiFp.apiV1ResetPasswordPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param body 
     */
    apiV1UpdateUserPost(params: {  "body"?: UpdateUserRequest; }, options?: any) {
        return IdentityApiFp.apiV1UpdateUserPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * IdentityApi - factory interface
 */
export const IdentityApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param body 
         */
        apiV1AddUserPost(params: {  "body"?: CreateUserRequest; }, options?: any) {
            return IdentityApiFp.apiV1AddUserPost(params, options)(fetch, basePath);
        },
        /** 
         */
        apiV1CurrentUserGet(options?: any) {
            return IdentityApiFp.apiV1CurrentUserGet(options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1DeleteUserPost(params: {  "body"?: IdentityUser; }, options?: any) {
            return IdentityApiFp.apiV1DeleteUserPost(params, options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1ForgetPasswordPost(params: {  "body"?: string; }, options?: any) {
            return IdentityApiFp.apiV1ForgetPasswordPost(params, options)(fetch, basePath);
        },
        /** 
         */
        apiV1GetUsersGet(options?: any) {
            return IdentityApiFp.apiV1GetUsersGet(options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1LoginPost(params: {  "body"?: LoginUserRequest; }, options?: any) {
            return IdentityApiFp.apiV1LoginPost(params, options)(fetch, basePath);
        },
        /** 
         */
        apiV1LogoutPost(options?: any) {
            return IdentityApiFp.apiV1LogoutPost(options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1ResetPasswordPost(params: {  "body"?: LoginUserRequest; }, options?: any) {
            return IdentityApiFp.apiV1ResetPasswordPost(params, options)(fetch, basePath);
        },
        /** 
         * @param body 
         */
        apiV1UpdateUserPost(params: {  "body"?: UpdateUserRequest; }, options?: any) {
            return IdentityApiFp.apiV1UpdateUserPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * ImpersonationApi - fetch parameter creator
 */
export const ImpersonationApiFetchParamCreator = {
    /** 
     * Gets the DataRow associated to the ImpersonationAuditHistory Record, and if the row has encrypted data, it will decrypt it.
     * @param id 
     */
    getimpersonationaudithistorydatarowGet(params: {  "id"?: number; }, options?: any): FetchArgs {
        const baseUrl = `/getimpersonationaudithistorydatarow`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param id 
     */
    getimpersonationaudithistoryrecordGet(params: {  "id"?: number; }, options?: any): FetchArgs {
        const baseUrl = `/getimpersonationaudithistoryrecord`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * ImpersonationApi - functional programming interface
 */
export const ImpersonationApiFp = {
    /** 
     * Gets the DataRow associated to the ImpersonationAuditHistory Record, and if the row has encrypted data, it will decrypt it.
     * @param id 
     */
    getimpersonationaudithistorydatarowGet(params: { "id"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = ImpersonationApiFetchParamCreator.getimpersonationaudithistorydatarowGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param id 
     */
    getimpersonationaudithistoryrecordGet(params: { "id"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = ImpersonationApiFetchParamCreator.getimpersonationaudithistoryrecordGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * ImpersonationApi - object-oriented interface
 */
export class ImpersonationApi extends BaseAPI {
    /** 
     * Gets the DataRow associated to the ImpersonationAuditHistory Record, and if the row has encrypted data, it will decrypt it.
     * @param id 
     */
    getimpersonationaudithistorydatarowGet(params: {  "id"?: number; }, options?: any) {
        return ImpersonationApiFp.getimpersonationaudithistorydatarowGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param id 
     */
    getimpersonationaudithistoryrecordGet(params: {  "id"?: number; }, options?: any) {
        return ImpersonationApiFp.getimpersonationaudithistoryrecordGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * ImpersonationApi - factory interface
 */
export const ImpersonationApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Gets the DataRow associated to the ImpersonationAuditHistory Record, and if the row has encrypted data, it will decrypt it.
         * @param id 
         */
        getimpersonationaudithistorydatarowGet(params: {  "id"?: number; }, options?: any) {
            return ImpersonationApiFp.getimpersonationaudithistorydatarowGet(params, options)(fetch, basePath);
        },
        /** 
         * @param id 
         */
        getimpersonationaudithistoryrecordGet(params: {  "id"?: number; }, options?: any) {
            return ImpersonationApiFp.getimpersonationaudithistoryrecordGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * SplitIoApi - fetch parameter creator
 */
export const SplitIoApiFetchParamCreator = {
    /** 
     * @param body 
     */
    apiV1SplitioFeaturetogglePost(params: {  "body"?: SplitTreatmentOptions; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/splitio/featuretoggle`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * SplitIoApi - functional programming interface
 */
export const SplitIoApiFp = {
    /** 
     * @param body 
     */
    apiV1SplitioFeaturetogglePost(params: { "body"?: SplitTreatmentOptions;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SplitFeatureToggle> {
        const fetchArgs = SplitIoApiFetchParamCreator.apiV1SplitioFeaturetogglePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * SplitIoApi - object-oriented interface
 */
export class SplitIoApi extends BaseAPI {
    /** 
     * @param body 
     */
    apiV1SplitioFeaturetogglePost(params: {  "body"?: SplitTreatmentOptions; }, options?: any) {
        return SplitIoApiFp.apiV1SplitioFeaturetogglePost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * SplitIoApi - factory interface
 */
export const SplitIoApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param body 
         */
        apiV1SplitioFeaturetogglePost(params: {  "body"?: SplitTreatmentOptions; }, options?: any) {
            return SplitIoApiFp.apiV1SplitioFeaturetogglePost(params, options)(fetch, basePath);
        },
    };
};


/**
 * SupportPortalApi - fetch parameter creator
 */
export const SupportPortalApiFetchParamCreator = {
    /** 
     * Unpair a list of devices
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalBulkUnpairPost(params: {  "xApiKey"?: string; "body"?: BulkUnpairRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/bulkUnpair`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Deprovisions/activates a specific device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalDeprovisionDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "deviceId" is set
        if (params["deviceId"] == null) {
            throw new Error("Missing required parameter deviceId when calling apiV1SupportPortalDeprovisionDeviceIdPost");
        }
        const baseUrl = `/api/v1/SupportPortal/deprovision/{deviceId}`
            .replace(`{${"deviceId"}}`, `${ params["deviceId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Moves devices from one Company to another Company for the Supportal and creates a new fleet if necessary
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params: {  "xApiKey"?: string; "body"?: SupportPortalDeviceMoveAndCreateRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/deviceMoveAndCreateFleets`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Moves devices from one Company to another Company for the Supportal
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalDeviceMovePost(params: {  "xApiKey"?: string; "body"?: SupportPortalDeviceMoveRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/deviceMove`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Attemps to wakeup a dormant device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "deviceId" is set
        if (params["deviceId"] == null) {
            throw new Error("Missing required parameter deviceId when calling apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost");
        }
        const baseUrl = `/api/v1/SupportPortal/deviceRemoteWakeup/{deviceId}`
            .replace(`{${"deviceId"}}`, `${ params["deviceId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param deviceId 
     * @param utcOffset 
     * @param xApiKey 
     */
    apiV1SupportPortalDevicedetailsDeviceIdGet(params: {  "deviceId": number; "utcOffset"?: number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "deviceId" is set
        if (params["deviceId"] == null) {
            throw new Error("Missing required parameter deviceId when calling apiV1SupportPortalDevicedetailsDeviceIdGet");
        }
        const baseUrl = `/api/v1/SupportPortal/devicedetails/{deviceId}`
            .replace(`{${"deviceId"}}`, `${ params["deviceId"] }`);
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "utcOffset": params["utcOffset"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns data for a list of devices
     * @param deviceIds 
     * @param xApiKey 
     */
    apiV1SupportPortalDevicelistdetailsGet(params: {  "deviceIds"?: Array<number>; "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/devicelistdetails`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "deviceIds": params["deviceIds"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets a list of all available fleets for a given list of cgRootIds
     * @param cgRootIds 
     * @param xApiKey 
     */
    apiV1SupportPortalEncompassCompanyStructureGet(params: {  "cgRootIds"?: Array<string>; "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/encompassCompanyStructure`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "cgRootIds": params["cgRootIds"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xApiKey 
     */
    apiV1SupportPortalExportGet(params: {  "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/Export`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns Geotab users for a fleet who are not yet Super Admins, including their Geotab User ID  and email address so the caller can pass the ID back when adding a Super Admin (Geotab only).
     * @param fleetId 
     * @param xApiKey 
     */
    apiV1SupportPortalFleetFleetIdGeotabUsersGet(params: {  "fleetId": number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "fleetId" is set
        if (params["fleetId"] == null) {
            throw new Error("Missing required parameter fleetId when calling apiV1SupportPortalFleetFleetIdGeotabUsersGet");
        }
        const baseUrl = `/api/v1/SupportPortal/fleet/{fleetId}/geotabUsers`
            .replace(`{${"fleetId"}}`, `${ params["fleetId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns the email addresses of all current Super Admin users for a fleet (Geotab or Standalone).
     * @param fleetId 
     * @param xApiKey 
     */
    apiV1SupportPortalFleetFleetIdSuperadminsGet(params: {  "fleetId": number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "fleetId" is set
        if (params["fleetId"] == null) {
            throw new Error("Missing required parameter fleetId when calling apiV1SupportPortalFleetFleetIdSuperadminsGet");
        }
        const baseUrl = `/api/v1/SupportPortal/fleet/{fleetId}/superadmins`
            .replace(`{${"fleetId"}}`, `${ params["fleetId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Adds a new Super Admin user for Geotab or Standalone. If the user already exists their role  is promoted to Super Admin rather than creating a duplicate.  Geotab: requires Email + GeotabUserId.  Standalone: requires Email, FirstName, LastName; PhoneNumber and JobTitle are optional.  Encompass: not supported.
     * @param fleetId 
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalFleetFleetIdSuperadminsPost(params: {  "fleetId": number; "xApiKey"?: string; "body"?: SupportPortalAddSuperAdminRequest; }, options?: any): FetchArgs {
        // verify required parameter "fleetId" is set
        if (params["fleetId"] == null) {
            throw new Error("Missing required parameter fleetId when calling apiV1SupportPortalFleetFleetIdSuperadminsPost");
        }
        const baseUrl = `/api/v1/SupportPortal/fleet/{fleetId}/superadmins`
            .replace(`{${"fleetId"}}`, `${ params["fleetId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns \&quot;live\&quot; data for a device; data that comes from our service providers like Streamax and FloLive
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalLivedevicedetailsDeviceIdGet(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "deviceId" is set
        if (params["deviceId"] == null) {
            throw new Error("Missing required parameter deviceId when calling apiV1SupportPortalLivedevicedetailsDeviceIdGet");
        }
        const baseUrl = `/api/v1/SupportPortal/livedevicedetails/{deviceId}`
            .replace(`{${"deviceId"}}`, `${ params["deviceId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Reprovisions/activates a specific device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalReprovisionDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any): FetchArgs {
        // verify required parameter "deviceId" is set
        if (params["deviceId"] == null) {
            throw new Error("Missing required parameter deviceId when calling apiV1SupportPortalReprovisionDeviceIdPost");
        }
        const baseUrl = `/api/v1/SupportPortal/reprovision/{deviceId}`
            .replace(`{${"deviceId"}}`, `${ params["deviceId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get SD Card Status for a given list of Serial Numbers
     * @param serialNumbers 
     * @param xApiKey 
     */
    apiV1SupportPortalSdcardstatusesGet(params: {  "serialNumbers"?: Array<string>; "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/sdcardstatuses`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "serialNumbers": params["serialNumbers"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get Sim Status for a given list of Iccid
     * @param iccids 
     * @param xApiKey 
     */
    apiV1SupportPortalSimstatusesGet(params: {  "iccids"?: Array<string>; "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/simstatuses`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "iccids": params["iccids"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xApiKey 
     */
    apiV1SupportPortalTestGet(params: {  "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/test`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Unpair a device
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUnpairPost(params: {  "xApiKey"?: string; "body"?: UnpairRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/unpair`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params: {  "xApiKey"?: string; "body"?: UpdateCameraDevicesVideoDisabledRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/updateCameraDevicesVideoDisabled`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Updates the ICCID of a device
     * @param xApiKey 
     * @param body Device ID and new ICCID
     */
    apiV1SupportPortalUpdateDeviceIccidPost(params: {  "xApiKey"?: string; "body"?: UpdateDeviceIccidRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/updateDeviceIccid`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Updates the status of the SIM cards for a list of devices
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUpdateDeviceSimCardStatesPost(params: {  "xApiKey"?: string; "body"?: UpdateDeviceSimCardStatesRequest; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/SupportPortal/updateDeviceSimCardStates`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * SupportPortalApi - functional programming interface
 */
export const SupportPortalApiFp = {
    /** 
     * Unpair a list of devices
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalBulkUnpairPost(params: { "xApiKey"?: string; "body"?: BulkUnpairRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<UnpairResponse>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalBulkUnpairPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Deprovisions/activates a specific device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalDeprovisionDeviceIdPost(params: { "deviceId": number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalDeprovisionDeviceIdPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Moves devices from one Company to another Company for the Supportal and creates a new fleet if necessary
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params: { "xApiKey"?: string; "body"?: SupportPortalDeviceMoveAndCreateRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SupportPortalMoveDevicesResponse> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Moves devices from one Company to another Company for the Supportal
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalDeviceMovePost(params: { "xApiKey"?: string; "body"?: SupportPortalDeviceMoveRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SupportPortalMoveDevicesResponse> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalDeviceMovePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Attemps to wakeup a dormant device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params: { "deviceId": number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param deviceId 
     * @param utcOffset 
     * @param xApiKey 
     */
    apiV1SupportPortalDevicedetailsDeviceIdGet(params: { "deviceId": number; "utcOffset"?: number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeviceDetailsResponse> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalDevicedetailsDeviceIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns data for a list of devices
     * @param deviceIds 
     * @param xApiKey 
     */
    apiV1SupportPortalDevicelistdetailsGet(params: { "deviceIds"?: Array<number>; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DeviceListDetailsResponse>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalDevicelistdetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets a list of all available fleets for a given list of cgRootIds
     * @param cgRootIds 
     * @param xApiKey 
     */
    apiV1SupportPortalEncompassCompanyStructureGet(params: { "cgRootIds"?: Array<string>; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EncompassCompanyStructure>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalEncompassCompanyStructureGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xApiKey 
     */
    apiV1SupportPortalExportGet(params: { "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SupportPortalExportResponse> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalExportGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns Geotab users for a fleet who are not yet Super Admins, including their Geotab User ID  and email address so the caller can pass the ID back when adding a Super Admin (Geotab only).
     * @param fleetId 
     * @param xApiKey 
     */
    apiV1SupportPortalFleetFleetIdGeotabUsersGet(params: { "fleetId": number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GeotabUserSummaryResponse>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalFleetFleetIdGeotabUsersGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns the email addresses of all current Super Admin users for a fleet (Geotab or Standalone).
     * @param fleetId 
     * @param xApiKey 
     */
    apiV1SupportPortalFleetFleetIdSuperadminsGet(params: { "fleetId": number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalFleetFleetIdSuperadminsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Adds a new Super Admin user for Geotab or Standalone. If the user already exists their role  is promoted to Super Admin rather than creating a duplicate.  Geotab: requires Email + GeotabUserId.  Standalone: requires Email, FirstName, LastName; PhoneNumber and JobTitle are optional.  Encompass: not supported.
     * @param fleetId 
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalFleetFleetIdSuperadminsPost(params: { "fleetId": number; "xApiKey"?: string; "body"?: SupportPortalAddSuperAdminRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalFleetFleetIdSuperadminsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns \&quot;live\&quot; data for a device; data that comes from our service providers like Streamax and FloLive
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalLivedevicedetailsDeviceIdGet(params: { "deviceId": number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LiveDeviceDetailsResponse> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalLivedevicedetailsDeviceIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Reprovisions/activates a specific device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalReprovisionDeviceIdPost(params: { "deviceId": number; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalReprovisionDeviceIdPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get SD Card Status for a given list of Serial Numbers
     * @param serialNumbers 
     * @param xApiKey 
     */
    apiV1SupportPortalSdcardstatusesGet(params: { "serialNumbers"?: Array<string>; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DeviceStorageState>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalSdcardstatusesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get Sim Status for a given list of Iccid
     * @param iccids 
     * @param xApiKey 
     */
    apiV1SupportPortalSimstatusesGet(params: { "iccids"?: Array<string>; "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SimStatusResponse>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalSimstatusesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xApiKey 
     */
    apiV1SupportPortalTestGet(params: { "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalTestGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Unpair a device
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUnpairPost(params: { "xApiKey"?: string; "body"?: UnpairRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Date> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalUnpairPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params: { "xApiKey"?: string; "body"?: UpdateCameraDevicesVideoDisabledRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Updates the ICCID of a device
     * @param xApiKey 
     * @param body Device ID and new ICCID
     */
    apiV1SupportPortalUpdateDeviceIccidPost(params: { "xApiKey"?: string; "body"?: UpdateDeviceIccidRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalUpdateDeviceIccidPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Updates the status of the SIM cards for a list of devices
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUpdateDeviceSimCardStatesPost(params: { "xApiKey"?: string; "body"?: UpdateDeviceSimCardStatesRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<number>> {
        const fetchArgs = SupportPortalApiFetchParamCreator.apiV1SupportPortalUpdateDeviceSimCardStatesPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * SupportPortalApi - object-oriented interface
 */
export class SupportPortalApi extends BaseAPI {
    /** 
     * Unpair a list of devices
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalBulkUnpairPost(params: {  "xApiKey"?: string; "body"?: BulkUnpairRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalBulkUnpairPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Deprovisions/activates a specific device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalDeprovisionDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalDeprovisionDeviceIdPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Moves devices from one Company to another Company for the Supportal and creates a new fleet if necessary
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params: {  "xApiKey"?: string; "body"?: SupportPortalDeviceMoveAndCreateRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Moves devices from one Company to another Company for the Supportal
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalDeviceMovePost(params: {  "xApiKey"?: string; "body"?: SupportPortalDeviceMoveRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalDeviceMovePost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Attemps to wakeup a dormant device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param deviceId 
     * @param utcOffset 
     * @param xApiKey 
     */
    apiV1SupportPortalDevicedetailsDeviceIdGet(params: {  "deviceId": number; "utcOffset"?: number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalDevicedetailsDeviceIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns data for a list of devices
     * @param deviceIds 
     * @param xApiKey 
     */
    apiV1SupportPortalDevicelistdetailsGet(params: {  "deviceIds"?: Array<number>; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalDevicelistdetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Gets a list of all available fleets for a given list of cgRootIds
     * @param cgRootIds 
     * @param xApiKey 
     */
    apiV1SupportPortalEncompassCompanyStructureGet(params: {  "cgRootIds"?: Array<string>; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalEncompassCompanyStructureGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xApiKey 
     */
    apiV1SupportPortalExportGet(params: {  "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalExportGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns Geotab users for a fleet who are not yet Super Admins, including their Geotab User ID  and email address so the caller can pass the ID back when adding a Super Admin (Geotab only).
     * @param fleetId 
     * @param xApiKey 
     */
    apiV1SupportPortalFleetFleetIdGeotabUsersGet(params: {  "fleetId": number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalFleetFleetIdGeotabUsersGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns the email addresses of all current Super Admin users for a fleet (Geotab or Standalone).
     * @param fleetId 
     * @param xApiKey 
     */
    apiV1SupportPortalFleetFleetIdSuperadminsGet(params: {  "fleetId": number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalFleetFleetIdSuperadminsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Adds a new Super Admin user for Geotab or Standalone. If the user already exists their role  is promoted to Super Admin rather than creating a duplicate.  Geotab: requires Email + GeotabUserId.  Standalone: requires Email, FirstName, LastName; PhoneNumber and JobTitle are optional.  Encompass: not supported.
     * @param fleetId 
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalFleetFleetIdSuperadminsPost(params: {  "fleetId": number; "xApiKey"?: string; "body"?: SupportPortalAddSuperAdminRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalFleetFleetIdSuperadminsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns \&quot;live\&quot; data for a device; data that comes from our service providers like Streamax and FloLive
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalLivedevicedetailsDeviceIdGet(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalLivedevicedetailsDeviceIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Reprovisions/activates a specific device
     * @param deviceId 
     * @param xApiKey 
     */
    apiV1SupportPortalReprovisionDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalReprovisionDeviceIdPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get SD Card Status for a given list of Serial Numbers
     * @param serialNumbers 
     * @param xApiKey 
     */
    apiV1SupportPortalSdcardstatusesGet(params: {  "serialNumbers"?: Array<string>; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalSdcardstatusesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get Sim Status for a given list of Iccid
     * @param iccids 
     * @param xApiKey 
     */
    apiV1SupportPortalSimstatusesGet(params: {  "iccids"?: Array<string>; "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalSimstatusesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xApiKey 
     */
    apiV1SupportPortalTestGet(params: {  "xApiKey"?: string; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalTestGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Unpair a device
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUnpairPost(params: {  "xApiKey"?: string; "body"?: UnpairRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalUnpairPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params: {  "xApiKey"?: string; "body"?: UpdateCameraDevicesVideoDisabledRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Updates the ICCID of a device
     * @param xApiKey 
     * @param body Device ID and new ICCID
     */
    apiV1SupportPortalUpdateDeviceIccidPost(params: {  "xApiKey"?: string; "body"?: UpdateDeviceIccidRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalUpdateDeviceIccidPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Updates the status of the SIM cards for a list of devices
     * @param xApiKey 
     * @param body 
     */
    apiV1SupportPortalUpdateDeviceSimCardStatesPost(params: {  "xApiKey"?: string; "body"?: UpdateDeviceSimCardStatesRequest; }, options?: any) {
        return SupportPortalApiFp.apiV1SupportPortalUpdateDeviceSimCardStatesPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * SupportPortalApi - factory interface
 */
export const SupportPortalApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Unpair a list of devices
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalBulkUnpairPost(params: {  "xApiKey"?: string; "body"?: BulkUnpairRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalBulkUnpairPost(params, options)(fetch, basePath);
        },
        /** 
         * Deprovisions/activates a specific device
         * @param deviceId 
         * @param xApiKey 
         */
        apiV1SupportPortalDeprovisionDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalDeprovisionDeviceIdPost(params, options)(fetch, basePath);
        },
        /** 
         * Moves devices from one Company to another Company for the Supportal and creates a new fleet if necessary
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params: {  "xApiKey"?: string; "body"?: SupportPortalDeviceMoveAndCreateRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalDeviceMoveAndCreateFleetsPost(params, options)(fetch, basePath);
        },
        /** 
         * Moves devices from one Company to another Company for the Supportal
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalDeviceMovePost(params: {  "xApiKey"?: string; "body"?: SupportPortalDeviceMoveRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalDeviceMovePost(params, options)(fetch, basePath);
        },
        /** 
         * Attemps to wakeup a dormant device
         * @param deviceId 
         * @param xApiKey 
         */
        apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalDeviceRemoteWakeupDeviceIdPost(params, options)(fetch, basePath);
        },
        /** 
         * @param deviceId 
         * @param utcOffset 
         * @param xApiKey 
         */
        apiV1SupportPortalDevicedetailsDeviceIdGet(params: {  "deviceId": number; "utcOffset"?: number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalDevicedetailsDeviceIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Returns data for a list of devices
         * @param deviceIds 
         * @param xApiKey 
         */
        apiV1SupportPortalDevicelistdetailsGet(params: {  "deviceIds"?: Array<number>; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalDevicelistdetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Gets a list of all available fleets for a given list of cgRootIds
         * @param cgRootIds 
         * @param xApiKey 
         */
        apiV1SupportPortalEncompassCompanyStructureGet(params: {  "cgRootIds"?: Array<string>; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalEncompassCompanyStructureGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xApiKey 
         */
        apiV1SupportPortalExportGet(params: {  "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalExportGet(params, options)(fetch, basePath);
        },
        /** 
         * Returns Geotab users for a fleet who are not yet Super Admins, including their Geotab User ID  and email address so the caller can pass the ID back when adding a Super Admin (Geotab only).
         * @param fleetId 
         * @param xApiKey 
         */
        apiV1SupportPortalFleetFleetIdGeotabUsersGet(params: {  "fleetId": number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalFleetFleetIdGeotabUsersGet(params, options)(fetch, basePath);
        },
        /** 
         * Returns the email addresses of all current Super Admin users for a fleet (Geotab or Standalone).
         * @param fleetId 
         * @param xApiKey 
         */
        apiV1SupportPortalFleetFleetIdSuperadminsGet(params: {  "fleetId": number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalFleetFleetIdSuperadminsGet(params, options)(fetch, basePath);
        },
        /** 
         * Adds a new Super Admin user for Geotab or Standalone. If the user already exists their role  is promoted to Super Admin rather than creating a duplicate.  Geotab: requires Email + GeotabUserId.  Standalone: requires Email, FirstName, LastName; PhoneNumber and JobTitle are optional.  Encompass: not supported.
         * @param fleetId 
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalFleetFleetIdSuperadminsPost(params: {  "fleetId": number; "xApiKey"?: string; "body"?: SupportPortalAddSuperAdminRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalFleetFleetIdSuperadminsPost(params, options)(fetch, basePath);
        },
        /** 
         * Returns \&quot;live\&quot; data for a device; data that comes from our service providers like Streamax and FloLive
         * @param deviceId 
         * @param xApiKey 
         */
        apiV1SupportPortalLivedevicedetailsDeviceIdGet(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalLivedevicedetailsDeviceIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Reprovisions/activates a specific device
         * @param deviceId 
         * @param xApiKey 
         */
        apiV1SupportPortalReprovisionDeviceIdPost(params: {  "deviceId": number; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalReprovisionDeviceIdPost(params, options)(fetch, basePath);
        },
        /** 
         * Get SD Card Status for a given list of Serial Numbers
         * @param serialNumbers 
         * @param xApiKey 
         */
        apiV1SupportPortalSdcardstatusesGet(params: {  "serialNumbers"?: Array<string>; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalSdcardstatusesGet(params, options)(fetch, basePath);
        },
        /** 
         * Get Sim Status for a given list of Iccid
         * @param iccids 
         * @param xApiKey 
         */
        apiV1SupportPortalSimstatusesGet(params: {  "iccids"?: Array<string>; "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalSimstatusesGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xApiKey 
         */
        apiV1SupportPortalTestGet(params: {  "xApiKey"?: string; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalTestGet(params, options)(fetch, basePath);
        },
        /** 
         * Unpair a device
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalUnpairPost(params: {  "xApiKey"?: string; "body"?: UnpairRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalUnpairPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params: {  "xApiKey"?: string; "body"?: UpdateCameraDevicesVideoDisabledRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalUpdateCameraDevicesVideoDisabledPost(params, options)(fetch, basePath);
        },
        /** 
         * Updates the ICCID of a device
         * @param xApiKey 
         * @param body Device ID and new ICCID
         */
        apiV1SupportPortalUpdateDeviceIccidPost(params: {  "xApiKey"?: string; "body"?: UpdateDeviceIccidRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalUpdateDeviceIccidPost(params, options)(fetch, basePath);
        },
        /** 
         * Updates the status of the SIM cards for a list of devices
         * @param xApiKey 
         * @param body 
         */
        apiV1SupportPortalUpdateDeviceSimCardStatesPost(params: {  "xApiKey"?: string; "body"?: UpdateDeviceSimCardStatesRequest; }, options?: any) {
            return SupportPortalApiFp.apiV1SupportPortalUpdateDeviceSimCardStatesPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * TelematicDeviceApi - fetch parameter creator
 */
export const TelematicDeviceApiFetchParamCreator = {
    /** 
     * Get telematic device by id
     * @param id 
     */
    apiV1TelematicDeviceGet(params: {  "id"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/telematicDevice`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "id": params["id"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all telematic devices
     * @param fleetId 
     * @param telematicProviderId 
     */
    apiV1TelematicdevicesGet(params: {  "fleetId"?: number; "telematicProviderId"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/telematicdevices`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "fleetId": params["fleetId"],
            "telematicProviderId": params["telematicProviderId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * TelematicDeviceApi - functional programming interface
 */
export const TelematicDeviceApiFp = {
    /** 
     * Get telematic device by id
     * @param id 
     */
    apiV1TelematicDeviceGet(params: { "id"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TelematicsDeviceResponse> {
        const fetchArgs = TelematicDeviceApiFetchParamCreator.apiV1TelematicDeviceGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all telematic devices
     * @param fleetId 
     * @param telematicProviderId 
     */
    apiV1TelematicdevicesGet(params: { "fleetId"?: number; "telematicProviderId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TelematicDeviceAdminResponse>> {
        const fetchArgs = TelematicDeviceApiFetchParamCreator.apiV1TelematicdevicesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * TelematicDeviceApi - object-oriented interface
 */
export class TelematicDeviceApi extends BaseAPI {
    /** 
     * Get telematic device by id
     * @param id 
     */
    apiV1TelematicDeviceGet(params: {  "id"?: string; }, options?: any) {
        return TelematicDeviceApiFp.apiV1TelematicDeviceGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all telematic devices
     * @param fleetId 
     * @param telematicProviderId 
     */
    apiV1TelematicdevicesGet(params: {  "fleetId"?: number; "telematicProviderId"?: string; }, options?: any) {
        return TelematicDeviceApiFp.apiV1TelematicdevicesGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * TelematicDeviceApi - factory interface
 */
export const TelematicDeviceApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Get telematic device by id
         * @param id 
         */
        apiV1TelematicDeviceGet(params: {  "id"?: string; }, options?: any) {
            return TelematicDeviceApiFp.apiV1TelematicDeviceGet(params, options)(fetch, basePath);
        },
        /** 
         * Get all telematic devices
         * @param fleetId 
         * @param telematicProviderId 
         */
        apiV1TelematicdevicesGet(params: {  "fleetId"?: number; "telematicProviderId"?: string; }, options?: any) {
            return TelematicDeviceApiFp.apiV1TelematicdevicesGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * WorkflowApi - fetch parameter creator
 */
export const WorkflowApiFetchParamCreator = {
    /** 
     * @param xApiKey 
     */
    apiV1WorkflowReEncryptDataPost(params: {  "xApiKey"?: string; }, options?: any): FetchArgs {
        const baseUrl = `/api/v1/workflow/ReEncryptData`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "X-Api-Key": params["xApiKey"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * WorkflowApi - functional programming interface
 */
export const WorkflowApiFp = {
    /** 
     * @param xApiKey 
     */
    apiV1WorkflowReEncryptDataPost(params: { "xApiKey"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = WorkflowApiFetchParamCreator.apiV1WorkflowReEncryptDataPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * WorkflowApi - object-oriented interface
 */
export class WorkflowApi extends BaseAPI {
    /** 
     * @param xApiKey 
     */
    apiV1WorkflowReEncryptDataPost(params: {  "xApiKey"?: string; }, options?: any) {
        return WorkflowApiFp.apiV1WorkflowReEncryptDataPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * WorkflowApi - factory interface
 */
export const WorkflowApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xApiKey 
         */
        apiV1WorkflowReEncryptDataPost(params: {  "xApiKey"?: string; }, options?: any) {
            return WorkflowApiFp.apiV1WorkflowReEncryptDataPost(params, options)(fetch, basePath);
        },
    };
};

